// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"_zeawEb8k5BoKpjDkArX","hole":"bfaGzWmER_qbYJOKgKMd","spotlight":"JNZtljPV3hrI7xO9o1R8","floater":"PP0PS2DQ7vAnKajBRpmT"};